import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import { BREAKPOINT_TABLET_SMALL } from '../../../../static/constants'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { Button, InputText, InputTextArea, Panel, Toggle } from '../../../atoms'
import { Form } from '../../../molecules'
import SidebarLayout from '../../_layouts/sidebarLayout'
import SvgIcon from 'components/atoms/SvgIcon'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  activity_title: 'activity_title',
  activity_body: 'activity_body',
  activity_link_type: 'activity_link_type',
  email_subject: 'email_subject',
  email_body: 'email_body',
  mobile_push_data: 'mobile_push_data',
  short_limit: 'short_limit',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('guide_notification_type', { scope: 'activerecord.models' }),
})

interface IProps {
  user: IJsonResponse
}

const AgentGuideNotificationTypeNew: React.FC<IProps> = props => {
  const { data: userData } = utilService.getDataFromJson(props.user)
  const [isActive, setIsActive] = React.useState(true)
  const [isActivity, setIsActivity] = React.useState(false)
  const [isEmail, setIsEmail] = React.useState(false)
  const [isMobilePush, setIsMobilePush] = React.useState(false)

  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const result = { ...values }
      result.is_active = isActive
      result.is_activity = isActivity
      result.is_email = isEmail
      result.is_mobile_push = isMobilePush
      const { flush } = await agentService.createGuideNotificationType(result)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/agent/guide_notification_types'
    },
    [isActive, isActivity, isEmail, isMobilePush]
  )

  return (
    <SidebarLayout user={userData}>
      <Wrapper>
        <Panel title={title}>
          <Form fields={FIELDS} handleSubmit={handleSubmit}>
            <InputText required={true} name="name" defaultValue="" label={I18n.t('generic.name')} />
            <S.FormItemWrapper>
              <InputText
                required={false}
                name="activity_title"
                defaultValue=""
                label="アプリ内 タイトル"
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputTextArea
                required={false}
                name="activity_body"
                defaultValue=""
                label="アプリ内 本文"
              />
              <p className="note">テンプレート変数は [[変数名]] 形式で使用できます</p>
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputText
                required={false}
                name="activity_link_type"
                defaultValue=""
                label="アプリ内 リンク"
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputText required={false} name="email_subject" defaultValue="" label="メール件名" />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputTextArea
                required={false}
                name="email_body"
                defaultValue=""
                label="メール本文"
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputTextArea
                required={false}
                name="mobile_push_data"
                defaultValue=""
                label="プッシュ通知"
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <Toggle
                name="is_active"
                checked={isActive}
                onChangeHandler={() => setIsActive(!isActive)}
                label="Active"
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <Toggle
                name="is_activity"
                checked={isActivity}
                onChangeHandler={() => setIsActivity(!isActivity)}
                label="アクティビティ"
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <Toggle
                name="is_email"
                checked={isEmail}
                onChangeHandler={() => setIsEmail(!isEmail)}
                label="メール"
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <Toggle
                name="is_mobile_push"
                checked={isMobilePush}
                onChangeHandler={() => setIsMobilePush(!isMobilePush)}
                label="プッシュ"
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <S.TooltipLabelWrapper>
                <S.LabelWithTooltip>
                  短時間送信制限
                  <S.Tooltip>
                    <S.TooltipIcon>?</S.TooltipIcon>
                    <S.TooltipText>
                      1時間に送信できる回数の制限。通知が届きすぎるのを防ぐ目的に使われますが、通常は0にしてください
                    </S.TooltipText>
                  </S.Tooltip>
                </S.LabelWithTooltip>
                <InputText required={false} name="short_limit" defaultValue="0" />
              </S.TooltipLabelWrapper>
            </S.FormItemWrapper>
            <div className="Buttons">
              <Button>
                <a href="/agent/guide_notification_types">
                  <SvgIcon
                    name="keyboard_arrow_left"
                    className="icon"
                    ariaHidden={true}
                    role="presentation"
                  />
                  {I18n.t('generic.back_to_index')}
                </a>
              </Button>
              <Button primary={true}>{I18n.t('generic.create')}</Button>
            </div>
          </Form>
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.TooltipLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  .InputText {
    flex: 1;
  }
`

S.LabelWithTooltip = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
  width: 180px;
  padding: 8px 12px 8px 0;
  font-size: 14px;
  font-weight: bold;
  @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    padding-right: 0;
    align-items: baseline;
    width: 100%;
  }
`

S.Tooltip = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`

S.TooltipIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${constants.COLORS.divider};
  color: #666;
  font-size: 12px;
  font-weight: bold;
  cursor: help;

  &:hover + span {
    visibility: visible;
    opacity: 1;
  }
`

S.TooltipText = styled.span`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: 280px;
  padding: 8px 12px;
  background-color: #333;
  color: #fff;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.5;
  border-radius: 4px;
  transition: opacity 0.2s ease;
  z-index: 1000;
  pointer-events: none;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
  }
`

S.FormItemWrapper = styled.div`
  margin-top: 24px;
  .note {
    margin-left: 240px;
    font-size: 14px;
    margin-top: 5px;
    color: #888;
    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      margin-left: 0px;
    }
  }
`

const Wrapper = styled.div`
  width: 100%;
  padding: 22px 40px 80px 46px;

  .Panel {
    max-width: none;
  }

  .Buttons {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 48px;

    .Button[type='submit'] {
      width: 160px;
    }

    .Button[type='button'] {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;

      .icon {
        margin-left: -10px;
      }
    }
  }

  .InputText + .InputText,
  .InputText + .CheckBox,
  .CheckBox + .CheckBox {
    margin-top: 24px;
  }

  @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
    padding: 16px 12px;
  }
`

export default AgentGuideNotificationTypeNew
